import React from 'react';

const SvgSmallGroup = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 100 100"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.566 22.37)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M40.77 24.074h20.173c1.288 0 2.476.695 3.108 1.817l8.296 17.425c.123.258.149.553.072.83L69.59 54.312l1.614-.027a1.189 1.189 0 011.209 1.188v3.547a1.19 1.19 0 01-1.19 1.188H10.534a1.19 1.19 0 01-1.15-.886l-2.532-9.624V24.074"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.07 57.832H5.993l-2.045-5.897M2.976 46.41V22.916c0-1.31 1.06-2.373 2.37-2.378l8.87-.03M37.203 20.508h18.985c1.288 0 2.476.694 3.108 1.817l8.487 17.826-1.76 11.784 2.823-.047v5.944h-5.108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M0 46.848h5.944v4.755H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.797,
  cy: 57.879,
  r: 5.944,
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57.059,
  cy: 57.879,
  r: 5.944,
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "square",
  strokeWidth: 2,
  d: "M50.613 57.831H23.999"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M55.128 24.795l4.93 10.992-14.252-.051V24.795zM34.244 24.795h7.353v10.698l-33.95.294V24.815l9.206-.02"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#53DD7D",
  d: "M18.453 34.63l.045-4.548a8.624 8.624 0 018.62-8.54 8.53 8.53 0 018.535 8.531v4.556"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinejoin: "bevel",
  strokeWidth: 2,
  d: "M32.91 13.75c0 3.954-.077 5.483-.928 8.449-.693 2.417-4.264 5.144-6.19 5.144-1.362 0-4.93-1.497-6.213-5.144-.563-1.6-.953-4.417-1.17-8.45"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24.46 22.376h2.748"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinejoin: "bevel",
  strokeWidth: 2,
  d: "M33.23 9.62c-1.06-4.223-3.769-7.243-7.138-7.243-3.277 0-6.234 3.2-7.361 7.244"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57.059,
  cy: 57.879,
  r: 2.377,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.831,
  cy: 57.879,
  r: 2.377,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.394,
  cy: 17.827,
  r: 1.359,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28.832,
  cy: 17.827,
  r: 1.359,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.092,
  cy: 2.377,
  r: 2.377,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M39.253 13.75H12.066l6.665-4.24h14.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M32.364 22.783c2.006 2.053 3.01 4.465 3.01 7.237v5.45M19.132 22.783c-2.464 2.007-3.696 4.412-3.696 7.216v5.472"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M45.806 40.189h3.555M37.473 40.189h3.566"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.248 13)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18.825,
  cy: 18.387,
  r: 7.132,
  fill: "#53DD7D"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.447,
  cy: 16.01,
  r: 7.132,
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16.088 4.122V0M22.508 6.005l2.245-3.457M26.906 11.084l3.737-1.742M27.854 17.707l4.083.574M25.072 23.793l3.111 2.704M19.448 27.413l1.136 3.963M12.728 27.413l-1.136 3.963M7.102 23.792l-3.11 2.704M4.322 17.707l-4.083.574M5.27 11.084L1.533 9.342M9.668 6.005L7.423 2.548"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M93.269 86.834H5.189"
})));

export default SvgSmallGroup;